import { motion } from "framer-motion";
import { UserRound, Zap, Building2, MapPin } from "lucide-react";
import { WHY_POINTS, IMAGES } from "../../data/content";

const icons = { UserRound, Zap, Building2, MapPin };

export const WhyUs = () => (
  <section id="warum" className="py-24 md:py-32 px-6 md:px-12 bg-[#171B21] border-y border-[#2A303A]" data-testid="whyus-section">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-[1fr_1.5fr] gap-14 lg:gap-20 items-start">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <div className="relative border border-[#2A303A]">
          <img src={IMAGES.portrait} alt="Arbeitsplatz von Nordhorizont Digital, Platzhalter-Foto" loading="lazy" className="w-full aspect-[4/5] object-cover" />
          <span className="absolute top-3 right-3 text-[10px] font-bold uppercase tracking-wider bg-black/70 text-white px-2 py-1" data-testid="portrait-placeholder-badge">
            Platzhalter-Foto
          </span>
        </div>
        <p className="font-display text-xl font-semibold mt-5">Jannik Deichmann</p>
        <p className="text-sm text-[#9AA3AF] mt-1">Gründer, 28, wohnhaft in der Nähe von Hamburg. Mehrjährige Erfahrung im Online-Design.</p>
      </motion.div>
      <div>
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">
          Warum Nordhorizont Digital
        </h2>
        <p className="mt-5 text-base md:text-lg text-[#9AA3AF] leading-relaxed max-w-2xl">
          Keine anonyme Agentur mit zehn Stockfoto-Gesichtern. Sie arbeiten mit einer Person, die Ihr Projekt von Anfang bis Ende verantwortet.
        </p>
        <div className="mt-12 grid sm:grid-cols-2 gap-x-10 gap-y-10">
          {WHY_POINTS.map((w, i) => {
            const Icon = icons[w.icon];
            return (
              <motion.div
                key={w.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 2) * 0.08, ease: "easeOut" }}
                data-testid={`why-point-${i}`}
              >
                <Icon className="w-6 h-6 text-[#2E5BFF]" />
                <h3 className="font-display text-lg md:text-xl font-semibold mt-4">{w.title}</h3>
                <p className="mt-2 text-sm text-[#9AA3AF] leading-relaxed">{w.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
